import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzModalRef } from 'ng-zorro-antd/modal'
import { MeetingRoomService } from 'src/app/services/meeting-room.service'
import { MeetingRoomForm } from 'src/app/services/interface/meeting-room.model'
import { NzMessageService } from 'ng-zorro-antd/message'

@Component({
  selector: 'app-add-room',
  templateUrl: './add-room.component.html',
  styleUrls: ['./add-room.component.scss'],
})
export class AddRoomComponent implements OnInit {
  form: FormGroup
  isLoading: boolean = false
  constructor(
    private fb: FormBuilder,
    private meetingRoomService: MeetingRoomService,
    private notification: NzNotificationService,
    private msg: NzMessageService,
    private modal: NzModalRef,
  ) {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      capacity: [null, Validators.compose([Validators.required, Validators.min(1)])],
      status: [true, Validators.compose([Validators.required])],
      notes: [null],
    })
  }

  ngOnInit(): void {
    this.form.statusChanges.subscribe(state => {
      this.modal.updateConfig({ nzOkDisabled: state === 'INVALID' })
    })
  }

  submitForm(): boolean {
    this.isLoading = true
    this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })

    if (this.form.valid) {
      var formSubs: MeetingRoomForm = this.form.value
      this.meetingRoomService.createMeetingRoom(this.form.value).subscribe(
        r => {
          this.notification.success('Success', 'Successfully Creating Room')
          this.modal.destroy()
          this.isLoading = false
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          return true
        },
        err => {
          this.notification.error('Error', err.error.message)
          this.isLoading = false
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          return false
        },
      )
    } else {
      this.msg.error('Please Fill Blank Form')
      this.isLoading = false
      this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
      return false
    }
  }
}
